/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import {
    asyncDefaults,
    makeAsyncReducer,
    makeAsyncResetReducer,
    mergeReducers,
} from 'ui-lottery/src/utils/async_utils';
import * as types from '../constants/actions';

const fetchReservations = makeAsyncReducer(types.FETCH_RESERVATIONS);
const createReservations = makeAsyncReducer(types.CREATE_RESERVATIONS);
const updateReservation = makeAsyncReducer(types.UPDATE_RESERVATION);
const resetReservations = makeAsyncResetReducer(types.RESET_RESERVATIONS, []);

const reservations = mergeReducers(
    asyncDefaults([]),
    types.PP_PREFIX,
    fetchReservations,
    createReservations,
    updateReservation,
    resetReservations
);

export default reservations;

export const selectors = {
    getReservations: (state) => state.activitypass.reservations.data,
    getReservationsError: (state) => state.activitypass.reservations.error,
};
